<section class="apps">
  <div class="app-section" aria-labelledby="import-data-title">
    <app-header-container [appDetails]="actionDetails"></app-header-container>
    <div class="app-section__content">
      <div class="app-section__items">
        @for (importDataItem of importData; track importDataItem) {
          <div
            class="app-section__item importer-item"
            (click)="onImportData(importDataItem)"
            tabindex="0"
            role="button"
            [attr.aria-label]="importDataItem.name"
            >
            <mds-icon [key]="importDataItem.icon" class="app-section__icon"></mds-icon>
            <div>
              <b class="app-section__item-title">{{ importDataItem.name }}</b>
              <p class="app-section__item-description">{{ importDataItem.description }}</p>
            </div>
          </div>
        }
      </div>
      <div class="app-section__more" (click)="onImportData()" tabindex="0" role="button" aria-label="See more imports">
        See more imports
        <mds-icon [key]="icons.ARROW_FORWARD" [pathColors]="['#8A9DA8']"></mds-icon>
      </div>
    </div>
  </div>
  <div class="app-section" aria-labelledby="apps-title" >
    <app-common-apps
      class="common-apps-container"
      [appDetails]="appDetails"
      [appsData]="categories$ | async"
      [appItems]="null"
      (onAppDataClick)="onAppData($event)"
      [isShowSeeMore]="true"
      [loading]="loading"
    ></app-common-apps>
  </div>
</section>
